export default (params) => ({
  trigger: {
    name: 'content_blocks.usps.show',
    params: params,
  },
  config: {
    schema: {
      title: {
        type: 'string',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'header',
          'mid-page',
          'footer',
          'header_personalized',
          'mid-page_personalized',
          'footer_personalized',
          'order_block',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'show_content_block',
    },
    nonInt: true,
  },
});
